import API from '../api'
import putUrl from './paths'

export const updateAssignedFinanceAnalyst = (organisationId, userId, financeAnalyst) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.updateCranFinanceAnalyst, financeAnalyst, { organisationId, userId })
			.then((response) => {
				resolve(response)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const updateRecommendedCreditLimit = ({ organisationId, userId, recommendedLimit }) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.updateRecommendedCreditLimit, recommendedLimit, { organisationId, userId })
			.then((response) => {
				resolve(response)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const updateApprovedCreditLimit = (organisationId, userId, approvedLimit) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.updateApprovedCreditLimit, approvedLimit, { organisationId, userId })
			.then((response) => {
				resolve(response)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const addVoterDetails = (organisationId, userId, voterDetails) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.addVoterDetails, voterDetails, { organisationId, userId })
			.then((response) => {
				resolve(response)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const addVotingOptions = (userId, organisationId, title, votingOptions) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.addVotingOptions, votingOptions, { userId, organisationId, title })
			.then((response) => {
				resolve(response)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const updateInspectionReportApi = (userId, inspectionReportId, financialInspectionReport) =>
	new Promise((resolve, reject) => {
		API.put(putUrl.updateInspectionReport, financialInspectionReport, { userId, inspectionReportId })
			.then((response) => {
				resolve(response)
			})
			.catch((error) => {
				reject(error)
			})
	})
